import screenfull from "screenfull";
import {logger} from '../utils/logger.js';
import { ContentFitType } from "../constant/index.js";
import { isDefaultColorOptions } from "../utils/index.js";
class PlayerUI {

    player;
    tag = 'PlayerUI'

    constructor(player) {

        this.player = player;


        const devicePixelRatio = window.devicePixelRatio || 1;
        logger.info(this.tag, `devicePixelRatio = ${devicePixelRatio}`);
        
        if (!player.options.useWebRtcRender && player.options.renderMode == 'canvas') {

            let canvasElement = document.createElement("canvas");
            canvasElement.style.position = "absolute";
            canvasElement.style.top = `${player.options.y}px`
            canvasElement.style.left = `${player.options.x}px`
            canvasElement.width = player.options.width;
            canvasElement.height = player.options.height;
    
            this.canvasElement = canvasElement;
            player.container.appendChild(this.canvasElement);

        } else {
            const videoElement = document.createElement('video');
            videoElement.muted = true;
            videoElement.style.position = "absolute";
            videoElement.style.top = `${player.options.y}px`;
            videoElement.style.left = `${player.options.x}px`;
            videoElement.width = player.options.width;
            videoElement.height = player.options.height;
            videoElement.setAttribute('playsinline','')
            videoElement.playsinline = true;
            videoElement.setAttribute('autoplay', '');
	        videoElement.autoplay = true;

            this.videoElement = videoElement;
            this.updateRenderOptions()
            player.container.appendChild(this.videoElement);

            if (!player.options.useWebRtcRender) {

                videoElement.ontimeupdate = ()=>{
                    
                    this.onVideoTimeUpdate()
                }

            }



        }

    }

    onVideoTimeUpdate() {

        if (this.player.options.playMode == 'live') {

            if (this.videoElement.buffered.length < 1) {

                return
            }

            let maxDelay = (this.player.options.videoBuffer + this.player.options.videoBufferDelay)/1000

            let ranges = this.videoElement.buffered
            let bufferEnd = ranges.end(ranges.length - 1);

            if (bufferEnd - this.videoElement.currentTime > maxDelay) {

                logger.info(this.tag, `video play current time ${this.videoElement.currentTime} is delay lastest buffer ${bufferEnd} too much, max delay ${maxDelay}`);

                this.videoElement.currentTime = bufferEnd;
            }

        }

    }

    getCanvas() {
  
        return this.canvasElement;
    }

    getOffScreenCanvas () {

        if (this.canvasElement) {

            return this.canvasElement.transferControlToOffscreen()
        }

        return
        
    }


    getVideo() {

        return this.videoElement;

    }

    resizeView() {

    
        if (this.canvasElement) {

            this.canvasElement.style.top = `${this.player.options.y}px`
            this.canvasElement.style.left = `${this.player.options.x}px`


            if (!this.player.options.useOffScreenCanvasRender) {

                this.canvasElement.width = this.player.options.width;
                this.canvasElement.height = this.player.options.height;
            }

        } else {

            this.videoElement.style.top = `${this.player.options.y}px`;
            this.videoElement.style.left = `${this.player.options.x}px`;
            this.videoElement.width = this.player.options.width;
            this.videoElement.height = this.player.options.height;
        }

    }

    updateRenderOptions() {

        if (!this.videoElement) {

            // let renderOptions = this.player.options.renderOptions
            // this.canvasElement.style.filter = `saturate(${renderOptions.saturate}) brightness(${renderOptions.brightness}) contrast(${renderOptions.contrast})  hue-rotate(${renderOptions.huerotate}deg)`

            return
        }

        let renderOptions = this.player.options.renderOptions

        if (renderOptions.contentFit == ContentFitType.contain) {
            this.videoElement.style.objectFit = 'contain'
        } else if (renderOptions.contentFit == ContentFitType.cover) {
            this.videoElement.style.objectFit = 'cover'
        } else {
            this.videoElement.style.objectFit = 'fill'
        }

        if (isDefaultColorOptions(renderOptions)) {
            this.videoElement.style.filter = ''
            
        } else {
            this.videoElement.style.filter = `saturate(${renderOptions.saturate}) brightness(${renderOptions.brightness}) contrast(${renderOptions.contrast})  hue-rotate(${renderOptions.huerotate}deg)`
        }

        

    }

    setFullscreen(flag) {

        if (flag) {
            screenfull.request(this.videoElement ?? this.canvasElement).then(() => {
            }).catch((e) => {
                logger.error('player', 'fullscreen request error', e);
            });
        } else {
            screenfull.exit().then(() => {
        
            }).catch((e) => {
                logger.error('player', 'fullscreen exit error', e);
    
            });
        }
    
    }

    isFullscreen() {

        return screenfull.isFullscreen
    }


    destroy() {

        if (this.canvasElement) {

            this.player.container.removeChild(this.canvasElement);
        }

        if (this.videoElement) {

            this.videoElement.ontimeupdate = undefined
            this.player.container.removeChild(this.videoElement);
        }
        

        logger.info(this.tag, 'PlayerUI destroy');

    }


}


export default PlayerUI;